import React from 'react'
import { DateRangePicker } from 'react-date-range'
import { OrdersContext } from 'contexts/OrdersContext'
import moment from 'moment'
import { $DCprimaryColor, DcButton, DcDropDown, PixelModal } from 'pixel-base'
import styled from 'styled-components'
import { IFilters } from 'client/../decl'

interface CourierList {
  courier_name: string
  courier_id: string
}

interface StoreList {
  store_name: string
  store_id: string
}

interface IProps {
  setIsClosePopover: (isClosePopover: boolean) => void
  filters: IFilters
  setFilters: (filters: IFilters) => void
  setAppliedFiltersIds: (filters: IFilters) => void
}

const Filter = (props: IProps) => {
  const { setIsClosePopover, filters, setFilters, setAppliedFiltersIds } = props
  const { state, setStateItem } = React.useContext(OrdersContext)
  const [showDateModal, setShowDateModal] = React.useState(false)
  const [courierList, setCourierList] = React.useState<any[]>([])
  const [storesList, setStoresList] = React.useState<any[]>([])
  const [tagsList, setTagsList] = React.useState<any[]>([])

  const [otherFilters, setOtherFilters] = React.useState<IFilters>({
    tag: null,
    start_date: null,
    end_date: null,
    courier_id: null,
    store_id: null,
    page: 0,
    page_size: 50,
  })

  React.useEffect(() => {
    if (filters) {
      setOtherFilters({
        tag: filters.tag ? filters.tag : null,
        start_date: filters.start_date || null,
        end_date: filters.end_date || null,
        courier_id: filters.courier_id,
        store_id: filters.store_id,
        page: filters.page,
        page_size: filters.page_size,
      })
    }
  }, [filters])

  React.useEffect(() => {
    if (state?.couriers) {
      setCourierList(state.couriers)
    }
    if (state?.linkedStores) {
      setStoresList(state.linkedStores)
    }
    if (state?.orderTags) {
      setTagsList(state.orderTags)
    }
  }, [state])

  return (
    <>
      <Container>
        <FormGroup>
          <DcDropDown
            size={16}
            placeholder="Tag"
            options={[
              {
                label: 'Tag',
                value: null,
              },
              ...tagsList.map((item) => {
                return {
                  label: `${item.tag_name} (${item.order_count})`,
                  value: item.tag_name,
                }
              }),
            ]}
            value={otherFilters.tag || ''}
            onChange={(e) => {
              setOtherFilters({
                ...otherFilters,
                tag: e.target.value,
              })
            }}
          />
          <DcDropDown
            required
            placeholder="Courier"
            options={[
              {
                courier_name: 'Courier',
                courier_id: '',
              },
              ...courierList,
            ].map((p: CourierList) => {
              return {
                label: p.courier_name,
                value: p.courier_id,
              }
            })}
            value={otherFilters.courier_id || ''}
            onChange={(e) => {
              setOtherFilters({
                ...otherFilters,
                courier_id: e.target.value,
              })
            }}
          />
          <DcDropDown
            required
            placeholder="Store"
            options={[
              {
                store_name: 'Store',
                store_id: null,
              },
              ...storesList,
            ].map((p: StoreList) => {
              return {
                label: p.store_name,
                value: p.store_id,
              }
            })}
            value={otherFilters.store_id || ''}
            onChange={(e) => {
              setOtherFilters({
                ...otherFilters,
                store_id: e.target.value,
              })
            }}
          />
          <ButtonsContainer>
            <DcButton
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setIsClosePopover(true)
              }}
            >
              Close
            </DcButton>
            <DcButton
              variant="secondary"
              size="sm"
              onClick={() => {
                setStateItem?.('selectedStatus', null)
                const resetFilters = {
                  store_id: null,
                  courier_id: null,
                  tag: null,
                  start_date: null,
                  end_date: null,
                  page: 0,
                  id: null,
                  page_size: 50,
                }
                setFilters(resetFilters)
                setAppliedFiltersIds(resetFilters)
                setOtherFilters({
                  tag: null,
                  start_date: null,
                  end_date: null,
                  courier_id: null,
                  store_id: null,
                  page: 0,
                  warehouse_id: [],
                  search: [],
                  page_size: 50,
                  sort_by: [],
                  sort_order: [],
                })
                setIsClosePopover(true)
              }}
            >
              Reset All
            </DcButton>
            <DcButton
              variant="primary"
              size="sm"
              onClick={() => {
                const newFilters = {
                  ...filters,
                  tag: otherFilters.tag,
                  start_date:
                    otherFilters.start_date &&
                    moment(otherFilters.start_date).format('llll') ===
                      moment().subtract(30, 'days').format('llll')
                      ? null
                      : otherFilters.start_date,
                  end_date:
                    otherFilters.end_date &&
                    moment(otherFilters.end_date).format('llll') ===
                      moment().format('llll')
                      ? null
                      : otherFilters.end_date,
                  courier_id: otherFilters.courier_id,
                  store_id: otherFilters.store_id,
                }
                setFilters(newFilters)
                setAppliedFiltersIds(newFilters)
                setIsClosePopover(true)
              }}
            >
              Apply
            </DcButton>
          </ButtonsContainer>
        </FormGroup>
      </Container>
      {showDateModal && (
        <PixelModal
          title={''}
          size={{
            width: '950px !important',
            maxWidth: '100% !important',
          }}
          handleClose={() => setShowDateModal(false)}
          show={showDateModal}
        >
          <DatePickerContainer>
            <DateRangePicker
              rangeColors={[$DCprimaryColor]}
              onChange={(item) => {
                if (
                  moment(item.selection.startDate).format('llll') !==
                  moment(item.selection.endDate).format('llll')
                ) {
                  setShowDateModal(false)
                } else if (
                  item.selection.startDate === '' &&
                  item.selection.endDate === ''
                ) {
                  setShowDateModal(false)
                }
                setOtherFilters({
                  ...otherFilters,
                  start_date: moment(item.selection.startDate).format('llll'),
                  end_date: moment(item.selection.endDate).format('llll'),
                })
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={[
                {
                  startDate:
                    otherFilters.start_date === null
                      ? new Date()
                      : new Date(otherFilters.start_date || ''),
                  endDate:
                    otherFilters.end_date === null
                      ? new Date()
                      : new Date(otherFilters.end_date || ''),
                  key: 'selection',
                },
              ]}
              direction="horizontal"
            />
          </DatePickerContainer>
        </PixelModal>
      )}
    </>
  )
}

const Container = styled.div`
  width: 100%;
  position: relative;
`
const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'flex-start')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
`
const DatePickerContainer = styled.div`
  overflow: auto;
`
export default Filter
